/* Bitki Rehberi — A-Z harf filtresi + anlık arama */
(function () {
  function norm(s) {
    return (s || '')
      .toString()
      .toLocaleLowerCase('tr')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/̇/g, '') // birleşik nokta (i̇)
      .trim();
  }

  function init(root) {
    if (!root || root.dataset.brehberInit === '1') return;
    root.dataset.brehberInit = '1';

    var input = root.querySelector('[data-brehber-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-brehber-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-brehber-group]'));
    var empty = root.querySelector('[data-brehber-empty]');
    var alphaItems = Array.prototype.slice.call(root.querySelectorAll('[data-brehber-alpha] [data-letter]'));
    var showAll = root.querySelector('[data-brehber-showall]');
    var topTerms = Array.prototype.slice.call(root.querySelectorAll('[data-brehber-term]'));

    // Başlangıç: ilk dolu harf seçili (örn. A). Hiç yoksa "tümü".
    var firstLetter = groups.length ? groups[0].getAttribute('data-letter') : null;
    var state = {
      query: '',
      mode: firstLetter ? 'letter' : 'all', // 'letter' | 'all' | 'search'
      letter: firstLetter
    };

    function setActiveLetter(letter) {
      alphaItems.forEach(function (item) {
        var on = letter && item.getAttribute('data-letter') === letter;
        item.classList.toggle('brehber-alpha__item--active', !!on);
      });
    }

    function render() {
      var q = norm(state.query);

      if (q !== '') {
        // ARAMA: tüm harflerde eşleşenleri göster
        var anyVisible = false;
        cards.forEach(function (card) {
          var match = norm(card.getAttribute('data-title')).indexOf(q) !== -1;
          card.hidden = !match;
          if (match) anyVisible = true;
        });
        groups.forEach(function (group) {
          group.hidden = group.querySelectorAll('[data-brehber-card]:not([hidden])').length === 0;
        });
        setActiveLetter(null);
        if (empty) empty.hidden = anyVisible;
        return;
      }

      // Arama yok → kartları sıfırla
      cards.forEach(function (card) { card.hidden = false; });
      if (empty) empty.hidden = true;

      if (state.mode === 'all') {
        groups.forEach(function (group) { group.hidden = false; });
        setActiveLetter(null);
      } else {
        // 'letter' → yalnız seçili harf grubu
        groups.forEach(function (group) {
          group.hidden = group.getAttribute('data-letter') !== state.letter;
        });
        setActiveLetter(state.letter);
      }
    }

    if (input) {
      input.addEventListener('input', function () {
        state.query = input.value;
        render();
      });
    }

    alphaItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        if (input) input.value = '';
        state.query = '';
        state.mode = 'letter';
        state.letter = item.getAttribute('data-letter');
        render();
      });
    });

    if (showAll) {
      showAll.addEventListener('click', function (e) {
        e.preventDefault();
        if (input) input.value = '';
        state.query = '';
        state.mode = 'all';
        render();
      });
    }

    topTerms.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var term = btn.getAttribute('data-brehber-term') || '';
        if (input) input.value = term;
        state.query = term;
        render();
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-brehber]').forEach(function (el) {
      init(el);
    });
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      init(e.target.querySelector('[data-brehber]'));
    }
  });
})();
